import styled from 'styled-components';

export const WhiteText = styled.div`
    color: white;
    text-align: center;
    margin-top: 2px;
    font-size: 14px;
`;
